import styled from 'styled-components'
import theme from 'styles/theme'

export const Wrapper = styled.section`
  color: ${theme.colors.sagedark};
  box-sizing: border-box;
  padding: 0 40px;

  ${theme.mediaQueries.medium} {
    padding: 0 20px;
  }
`

export const Center = styled.div`
  ${theme.mediaQueries.medium} {
    margin: 0 auto;
    max-width: 1180px;
  }
`

export const Grid = styled.div`
  margin: 0 auto;
  max-width: 380px;

  ${theme.mediaQueries.medium} {
    display: flex;
    justify-content: space-between;
    max-width: none;

    ${({ count }) =>
      count < 3 &&
      `
      justify-content: center;
    `}

    ${({ count }) =>
      count > 3 &&
      `
      flex-wrap: wrap;
    `}
  }
`
